import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCalendars as GetCalendarsQuery,
    GetCalendarsVariables as GetCalendarsVariables,
    GetCalendars_calendars as Calendars,
} from 'nutshell-graphql-types';

import GET_CALENDARS from '../queries/get-calendars.graphql';

export const useGetCalendars = (
    username?: string,
    skip = false
): {
    calendars: Calendars[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetCalendarsQuery, GetCalendarsVariables>(
        GET_CALENDARS,
        {
            variables: {username},
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    const calendars = data ? data.calendars : null;

    return {
        calendars: calendars || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
